var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',{attrs:{"breadcrumbs":_vm.breadcrumbs}},[_c('h1',{staticStyle:{"display":"none"}},[_vm._v("Pasang Iklan Primary")]),_c('packages')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }